import React, { useEffect } from "react";
import { ConsultationFormWidget } from "../../Components/ConsultationFormWidget";
import {
  requestGetConsultantByID,
  requestListService,
  useConsultantDispatch,
  useConsultantState,
  useConsultationDispatch,
  useConsultationState,
} from "../../Context";
import { useParams } from "react-router-dom";

const ConsultationForm = () => {
  const consultationDispatch = useConsultationDispatch();
  const consultantDispatch = useConsultantDispatch();
  const { id } = useParams();
  const { serviceLoading, services } = useConsultationState();
  const { consultant, loading, error } = useConsultantState();

  useEffect(() => {
    if (id) {
      requestGetConsultantByID(consultantDispatch, { id });
    }
  }, [consultantDispatch, id]);

  useEffect(() => {
    if (services.length === 0 && !serviceLoading) {
      requestListService(consultationDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-white border border-gray-200 rounded-md sm:rounded-lg shadow-sm">
      <ConsultationFormWidget
        consultant={consultant}
        consultantLoading={loading}
        consultantError={error}
        categories={services}
        loading={serviceLoading}
      />
    </div>
  );
};

export default ConsultationForm;
